import type { CrossMarketStatus } from '../../services/crossMarketApi';

export default function CrossMarketKrSnapshot({ data }: { data: CrossMarketStatus }) {
  const kr = data.markets.KR;
  return (
    <article className="market-snapshot-card kr">
      <CardHead code="KR" title="국내 검증" mode="Toss Read-only · Replay" />
      <MetricRow label="Replay" value={`${kr.run_count}회 · 판단 ${kr.decisions}건`} />
      <MetricRow label="주문/체결" value={`${kr.orders} / ${kr.fills}`} />
      <MetricRow label="Live Shadow" value={shadowLabel(kr)} />
      <MetricRow label="Live 주문" value={liveOrderLabel(kr)} />
      <MetricRow label="KR 보유 PnL" value={livePnlLabel(kr)} />
      <MetricRow label="Shadow-Live" value={shadowLiveLabel(kr)} />
      <MetricRow label="비용 모델" value={kr.cost_model_version || '데이터 없음'} />
      <MetricRow label="상태" value={krGateLabel(kr)} />
    </article>
  );
}

function CardHead({ code, title, mode }: { code: string; title: string; mode: string }) {
  return (
    <div className="market-card-head">
      <span>{code}</span>
      <div>
        <strong>{title}</strong>
        <small>{mode}</small>
      </div>
    </div>
  );
}

function MetricRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="market-metric-row">
      <small>{label}</small>
      <span>{value}</span>
    </div>
  );
}

function krGateLabel(kr: CrossMarketStatus['markets']['KR']) {
  const gate = kr.performance_gate;
  if (!gate) return kr.performance_gate_passed ? 'K2 통과' : 'K2 성과 검증 전';
  if (gate.passed) return `K2 통과 · SELL ${gate.totals.SELL}`;
  return `K2 표본 미달 · ${gate.blockers.join(', ') || '확인 필요'}`;
}

function shadowLabel(kr: CrossMarketStatus['markets']['KR']) {
  const shadow = kr.live_shadow;
  if (!shadow) return '데이터 없음';
  return shadow.ready ? `${shadow.recent_count}건 저장` : '대기';
}

function liveOrderLabel(kr: CrossMarketStatus['markets']['KR']) {
  const orders = kr.live_summary?.orders;
  if (!orders) return '데이터 없음';
  return `최근 ${orders.count}건 · open ${orders.open_count}`;
}

function shadowLiveLabel(kr: CrossMarketStatus['markets']['KR']) {
  const compare = kr.live_summary?.shadow_live_comparison;
  if (!compare) return '데이터 없음';
  if (compare.status === 'no_live_orders') return '비교할 live 주문 없음';
  return compare.alert_required ? `차이 ${compare.divergent_symbols.length}개` : '차이 없음';
}

function livePnlLabel(kr: CrossMarketStatus['markets']['KR']) {
  const holdings = kr.live_summary?.holdings;
  if (!holdings) return '데이터 없음';
  return `${holdings.count}개 · ${krw(holdings.total_unrealized_pl)}`;
}

function krw(value?: number) {
  if (value === undefined || value === null) return '데이터 없음';
  return `${Math.round(value).toLocaleString('ko-KR')}원`;
}
